import styled from 'styled-components';

export const ButtonSimple = styled.button`
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 0.2rem;
  color: #333;
  letter-spacing: 0.025rem;
  padding: 0.2rem 0.5rem;

  &:hover {
    cursor: pointer;
  }
`;

export const ButtonSimpleNoColor = styled.button`
  border: none;
  border-radius: 0.2rem;
  letter-spacing: 0.025rem;
  padding: 0.25rem 0.55rem;

  &:hover {
    cursor: pointer;
  }
`;
